import { Info } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'

const LegInfo = ({ selectedLeg }: { selectedLeg: 0 | 1 }) => {
    const tCommon = useTranslations('common')

    return (
        <Box bgcolor={'#f9fafb'} p={1} px={2}>



            <Typography
                fontSize={12}
                fontWeight={500}
                color='#000'
                border={'1px solid #E0E0E0'}
                borderRadius={1}
                p={0.5}
                display={"flex"}
                alignItems={"center"}
                gap={0.5}
            >
                <Info fontSize='small' color='action' />  <span>{selectedLeg === 0 ? tCommon('pricesShownDepartureNote') : tCommon('pricesShownReturnNote')}</span>
            </Typography>
        </Box>


    )
}

export default LegInfo
